import Banner from "@/components/Banner";

export default function CareerServicesDashboardSectionPrompt() {
  return (
    <Banner
      description="Select a section to view dashboard data."
      subText="Choose a section from the selector above."
      variant="info"
      testId="career-services-dashboard-section-required"
    />
  );
}
